/**
 * _StatusPillSmall — Phase R10.4 (2026-07-05)
 *
 * Tiny read-only status pill for the DuplicateComparisonPanel row.
 * Pure presentational; does NOT replace the larger HeaderStatus used
 * elsewhere on the detail page.
 */

const CONFIG = {
  pending_ai_analysis:  { label: 'Analyzing',  cls: 'bg-sky-500/15 text-sky-300 border-sky-500/35' },
  pending_owner_review: { label: 'Pending',    cls: 'bg-amber-500/15 text-amber-300 border-amber-500/35' },
  approved:             { label: 'Approved',   cls: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/35' },
  rejected:             { label: 'Rejected',   cls: 'bg-red-500/15 text-red-300 border-red-500/35' },
};

export default function StatusPillSmall({ status }) {
  const cfg = CONFIG[status] || { label: status || '—', cls: 'bg-white/5 text-white/70 border-white/15' };
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] font-semibold whitespace-nowrap ${cfg.cls}`}
      data-testid={`status-pill-sm-${status || 'unknown'}`}
    >
      {cfg.label}
    </span>
  );
}
